import * as angular from "angular";
import { AppTypeDataProvider } from "../../../data-provider/app-type.dp";
import { EffortDataProvider } from "../../../data-provider/effort.dp";
import { Team } from "../../../models/team.model";
import { User } from "../../../models/user.model";
import { ScreenUtils } from "../../../helper/screen.helper";
import { TeamDataProvider } from "../../../data-provider/team.dp";

let TeamScoreBoardListComponent = {
    selector: "vcTeamScoreBoardList",
    templateUrl:
        "/angular/components/team/score-board/team-score-board-list.component.html",
    bindings: {
        teamId: "=",
        filter: "=",
    },
    controller: class TeamScoreBoardListController {
        // * bindings for typescript compiler *
        public teamId?: string | number;
        public filter?: any;
        // ************************************

        public loadingStatus = {
            stats: false,
            content: true,
            details: false,
        };

        public team: Team;
        private readonly $scope: any;
        private readonly modelsUtils: any;
        private $location: any;
        private dataProvider: TeamDataProvider;

        constructor(
            $scope: any,
            $location: any,
            __env: any,
            ModelsUtils: any,
            TeamDataProvider: TeamDataProvider
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.modelsUtils = ModelsUtils;
            this.dataProvider = TeamDataProvider;
            this.team = this.modelsUtils.team();
            this.dataProvider.clearAll();
        }

        $onInit() {
            this.$scope.$watch(
                () => this.filter,
                (newValue: object, oldValue: object) => {
                    if (
                        oldValue &&
                        newValue !== oldValue &&
                        !this.loadingStatus.content
                    ) {
                        this.loadTeamData("content");
                    }
                },
                true
            );

            this.loadTeamData("content");
        }

        loadTeamData(loading: string): void {
            this.dataProvider.clearAll();
            this.checkLoading(loading, "start");
            this.dataProvider
                .getTeam(this.teamId, this.filter)
                .then((returnedTeam: Team) => {
                    this.team = returnedTeam;
                    if (this.team.users.length) {
                        this.team.users.forEach(
                            (user: object, index: number) => {
                                this.team.users[index] =
                                    this.modelsUtils.user(user);
                            }
                        );
                    }
                    this.checkLoading(loading, "finish");
                });
        }

        goToUser(user: User): void {
            this.$location.url("/user/" + user.uid);
        }

        changeOrder(column: string): void {
            if (column == this.filter.order) {
                this.filter.direction =
                    this.filter.direction == "asc" ? "desc" : "asc";
            } else {
                this.filter.order = column;
                this.filter.direction = "desc";
            }

            this.loadTeamData("stats");
        }

        checkLoading(loading: string, status: string): void {
            if (loading == "content") {
                this.loadingStatus.content = status == "start";
            } else {
                this.loadingStatus.stats = status == "start";
            }
        }
    },
};

angular
    .module("team")
    .component(
        TeamScoreBoardListComponent.selector,
        TeamScoreBoardListComponent
    );
